import React from "react";
import EvaluationTool from "@/features/EvaluationTool";

/**
 * Test page for the EvaluationTool wizard
 */
const EvaluationToolTest: React.FC = () => {
  return <EvaluationTool />;
};

export default EvaluationToolTest;
